import React from 'react';
import { Link } from 'react-router-dom';
import { ProductCard } from './ProductCard';
export const PopularDevices = () => {
  const popularProducts = [{
    id: 'iphone-15',
    name: 'iPhone 15',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/adSmqXZtwMRaADCVDQGH75/image.png',
    startingPrice: 799
  }, {
    id: 'iphone-14',
    name: 'iPhone 14',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 699
  }, {
    id: 'galaxy-s23',
    name: 'Galaxy S23',
    brand: 'Samsung',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 749
  }, {
    id: 'galaxy-s22',
    name: 'Galaxy S22',
    brand: 'Samsung',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 649
  }];
  return <div className="py-8" data-id="element-1200">
      <div className="flex justify-between items-center mb-6" data-id="element-1201">
        <h2 className="text-2xl font-bold text-gray-800" data-id="element-1202">Popular Devices</h2>
        <span className="text-gray-400 text-sm" data-id="element-1203">
          You can totally sit with them
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1204">
        {popularProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-1205" />)}
      </div>
    </div>;
};